import CarouselConfig from 'components/carousel';
import moduleStyles from './carousel.module.scss';
import './carousel.scss';

/* eslint-disable global-require, import/no-dynamic-require, import/no-webpack-loader-syntax, max-len */
const previous = require('!svg-inline-loader!./simple-arrow-left.svg');
const next = require('!svg-inline-loader!./simple-arrow-right.svg');
/* eslint-enable */

// Replace the icons used in the parent theme.
Object.assign(
  CarouselConfig.options,
  { icons: { previous, next }, moduleStyles },
);
